module.exports = __webpack_public_path__ + "static/img/7.e507a3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/7.png
// module id = YAK8
// module chunks = 0